// Parse a bare "YYYY-MM-DD" event date as a LOCAL date.
//
// `new Date("2026-06-17")` is parsed as UTC midnight, so `.toLocaleDateString`
// then shifts it into the viewer's zone — for any visitor west of UTC (the
// Americas, which the directory serves) the event renders one day early, and
// the map disagrees with the calendar (pages/Events.js builds dates from local
// parts and is correct). Build from local parts so every surface agrees.
export function parseLocalDate(dateStr) {
  if (!dateStr) return null;
  const [y, m, d] = String(dateStr).split('-').map(Number);
  if (!y || !m || !d) return new Date(dateStr); // fall back for unexpected formats
  return new Date(y, m - 1, d);
}
